import React from 'react';

function RobotsPage() {
  const robotsTxt = `# Pokemon Stats Database - robots.txt
# Updated: ${new Date().toISOString().split('T')[0]}

# Allow all search engines
User-agent: *
Allow: /

# AI Bots - Explicitly allowed
User-agent: ChatGPT-User
Allow: /

User-agent: GPTBot
Allow: /

User-agent: Google-Extended
Allow: /

User-agent: Claude-Web
Allow: /

User-agent: ClaudeBot
Allow: /

User-agent: anthropic-ai
Allow: /

User-agent: PerplexityBot
Allow: /

User-agent: Cohere-ai
Allow: /

# Disallow dynamic search URLs with parameters
Disallow: /search?*
Disallow: /*?q=*
Disallow: /*?page=*
Disallow: /*?sort=*

# Disallow admin or private areas (if any)
Disallow: /admin/
Disallow: /private/
Disallow: /.env
Disallow: /config/

# Allow important pages
Allow: /pokemon/
Allow: /type/
Allow: /top/
Allow: /compare
Allow: /about
Allow: /contact

# Sitemap location
Sitemap: https://example.com/sitemap.xml

# Crawl delay for respectful crawling
Crawl-delay: 1`;

  // Set content type for text
  React.useEffect(() => {
    document.querySelector('meta[name="content-type"]')?.setAttribute('content', 'text/plain');
  }, []);

  return (
    <pre style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', margin: 0, padding: '20px' }}>
      {robotsTxt}
    </pre>
  );
}

export default RobotsPage;